import axios from 'axios' // 引入axios
import utils from './utils'


axios.defaults.timeout = 5000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 测试地址
// axios.defaults.baseURL = 'https://zt148.ztvcar.com/zt-api/api/v1/';
// 正式地址
axios.defaults.baseURL = 'https://v2-api.ztvcar.com/api/v1/'

// 封装get请求
export function AxiosGet(url, params) {
  params.platform = 'wap_spread';
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

// 封装post请求npm
// const from = utils.getUrlParam('') != null && utils.getUrlParam('') == 'wx.zt' ? 'wx.zt' : 'wx.ztao'
const from = utils.getUrlParam('') != null && utils.getUrlParam('') == 'wx.ztao' ? 'wx.ztao' : 'wx.zt'
export function AxiosPost(url, params,platform) {
  params.platform = platform ? platform : 'wap_spread';
  params.from = from
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data)
      }).catch(err => {
      reject(err.data)
    })
  })
}




// WEBPACK FOOTER //
// ./src/api/axios.js